import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootReducer from "../reducers";
import rootSaga from "../sagas";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["audit/uploadAuditReport"],
        // Ignore these field paths in all actions
        ignoredActionPaths: ["meta.file"],
        // Ignore these paths in the state
        ignoredPaths: ["audit.uploadFile"],
        ignoredActions: [
          "audit/uploadAuditReport",
          "collaborativeForm/uploadFile",
        ],
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
